import React from "react";
import { useTranslation } from "react-i18next";

import { ModalPlayerRiskTabs } from "configs/types";

import ListRiskProfileTab from "./ListProfileTab";
import ListRiskRestrictionsTab from "./ListRestrictionsTab";
import ListRiskCalculatedTab from "./ListCalculatedTab";
import { RestrictionRow } from "store/players/list/slice";

interface Props {
  rows: RestrictionRow[];
  setRows: React.Dispatch<React.SetStateAction<RestrictionRow[]>>;
  setInitialRows: React.Dispatch<React.SetStateAction<RestrictionRow[]>>;
  showRestrictionErrors: boolean;
  activeTab: ModalPlayerRiskTabs;
  setActiveTab: React.Dispatch<React.SetStateAction<ModalPlayerRiskTabs>>;
}

const ListRiskTab: React.FC<Props> = ({
  rows,
  setRows,
  showRestrictionErrors,
  setInitialRows,
  activeTab,
  setActiveTab,
}) => {
  const { t } = useTranslation();
  const tabs: ModalPlayerRiskTabs[] = [
    ModalPlayerRiskTabs.profile,
    ModalPlayerRiskTabs.restrictions,
    ModalPlayerRiskTabs.calculated,
  ];
  const isTableTab =
    activeTab === ModalPlayerRiskTabs.restrictions ||
    activeTab === ModalPlayerRiskTabs.calculated;
  const renderTab = () => {
    if (activeTab === ModalPlayerRiskTabs.profile) {
      return <ListRiskProfileTab />;
    }

    if (activeTab === ModalPlayerRiskTabs.restrictions) {
      return (
        <ListRiskRestrictionsTab
          rows={rows}
          setRows={setRows}
          showRestrictionErrors={showRestrictionErrors}
          setInitialRows={setInitialRows}
        />
      );
    }

    if (activeTab === ModalPlayerRiskTabs.calculated) {
      return <ListRiskCalculatedTab />;
    }

    return null;
  };

  return (
    <div className="player-risk-wrap">
      <div className="game-modal-tabs small">
        {tabs.map((el) => (
          <div
            key={el}
            className={`tab-item ${activeTab === el ? "active" : ""}`}
            onClick={() => {
              setActiveTab(el);
            }}
          >
            {t(el)}
          </div>
        ))}
      </div>
      <div className="risk-wrapper">
        <div
          className={`risk-content ${isTableTab ? "risk-content--table" : ""}`}
        >
          {renderTab()}
        </div>
      </div>
    </div>
  );
};

export default ListRiskTab;
